<template>
  <fanzone-form
    :id='id'
    redirectTo='/#/fanzones'
    label='Festiwale'
    :idStepsEvent='true'
    :idsRelatedEvents='true'
    :scenesEditor='true'
  />
</template>

<script>
	import fanzoneForm from '../components/FanzoneForm'
	
	export default {
    props: ['id'],
    components: { fanzoneForm },
	}
</script>
